import {combineReducers} from "redux";

const searchCriteria=(storedCriteria =[] , action) => {
    if(action.type =="STORE_CRITERIA")
    {
        return action.payload;
    }
    if(action.type =="CLEAR_CRITERIA")
    {
        return [];
    }
    if(action.type =="SOFT_DEL_CRITERIA")
    {
        return storedCriteria;
    }
    if(action.type =="HOME_LINK_CLICKED")
    {
        return [];
    }
    return storedCriteria;
}


const criteriaDeletedBy=(criteriaDeletedBy="", action) => {
    if(action.type=="SOFT_DEL_CRITERIA")
    {
        return action.payload.deletedBy;
    }
    if(action.type =="STORE_CRITERIA")
    {
        return "";
    }
    if(action.type =="CLEAR_CRITERIA")
    {
        return "";
    }
    return criteriaDeletedBy;
}

const productDetailsOpener= (opener="" , action) =>
{
    if(action.type =="STORE_CRITERIA")
    {
        return "Home";
    }
    if(action.type =="CLEAR_CRITERIA")
    {
        return "";
    }
    if(action.type =="HOME_LINK_CLICKED")
    {
        return "";
    }
    return opener;
}

const homeLinkClicked= (isHomeLinkClicked=false , action) =>
{
    if(action.type =="HOME_LINK_CLICKED")
    {
        return isHomeLinkClicked?false:true;
    }
    
    return isHomeLinkClicked;
}

const reducers = combineReducers( {
    storedSearchCriteria: searchCriteria,
    productDetailsOpener: productDetailsOpener,
    criteriaDeletedBy: criteriaDeletedBy,
    homeLinkClicked: homeLinkClicked
})

export default reducers;



// WEBPACK FOOTER //
// ./components/redux/reducer/SearchCriteriaReducer.js